<template>
    <div class="min-h-screen flex items-center justify-center p-6 ct-bg-1--alt">
        <div class="w-full max-w-sm space-y-12 text-center">
            <img v-if="logo" :src="logo" alt="logo" class="h-12 mx-auto" />
            <EasyToolsIcon v-else class="h-8 mx-auto" />
            <div class="w-full space-y-8">
                <div class="space-y-3">
                    <p class="ct-text-1 text-3xl font-semibold">
                        {{ $t("r_player.access.unlock_access") }}🔓
                    </p>
                    <p class="ct-text-3 text-base">
                        {{ $t("r_player.access.with_access") }}
                    </p>
                </div>
                <div class="space-y-6">
                    <a class="w-full block" :href="loginLink">
                        <ButtonPrimaryLg class="w-full">
                            {{ $t("r_player.access.login") }}
                        </ButtonPrimaryLg>
                    </a>
                    <p class="ct-text-3 text-base">
                        {{ $t("r_player.access.without_access") }}
                    </p>
                    <div class="w-full space-y-3">
                        <a
                            class="block w-full"
                            v-for="item in cartUrls"
                            :key="item.url"
                            :href="item.url"
                        >
                            <ButtonSecondaryLg class="w-full">
                                <ShoppingCartIcon class="flex-shrink-0" />
                                <span>{{ item.name }}</span>
                            </ButtonSecondaryLg>
                        </a>
                    </div>
                    <p class="ct-text-3 text-base">
                        {{ $t("r_player.access.need_help") }}
                        <a class="underline" href="mailto:hello@easy.tools">{{
                            $t("r_player.access.contact_us")
                        }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ButtonPrimaryLg, ButtonSecondaryLg } from "@easy/ui/buttons";
import { loginService } from "@/auth/service/login.service";
import { ShoppingCartIcon, EasyToolsIcon } from "@easy/ui/icons";
import { i18n } from "@/i18n";

export default {
    name: "AccessPage",
    props: {
        cartUrls: Array,
        logo: String,
    },
    components: {
        ButtonPrimaryLg,
        ButtonSecondaryLg,
        EasyToolsIcon,
        ShoppingCartIcon,
    },
    computed: {
        loginLink() {
            return loginService.generateLogInLink(i18n.global.locale.value);
        },
    },
};
</script>
